$(document).ready(function() {

  //
  // device orientation
  //

  checkDeviceOrientatation();

  // IQ test
  iqTestParallax();
});

//
// on resize
//

$(window).resize = () => checkDeviceOrientatation();

//
// check device orientation change
//

var checkDeviceOrientatation = function() {
  if ($('.grid.mobile').length && (window.innerWidth > window.innerHeight)) {
    $('.listing-ad-placement').remove();
  }
};

//
// IQ test parallax
//

var iqTestParallax = function() {
  const parallaxClass = '.parallax';
  if (!$(parallaxClass).length) { return; }

  return new Rellax(parallaxClass);
};
